const content = {
  strictlyNecessary: {
    title: 'Strictly Necessary Cookies',
    text: 'These cookies are necessary for our website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.',
  },
  functional: {
    title: 'Functional Cookies',
    text: 'These cookies enable the website to provide enhanced functionality and personalisation. They may be set by us or by third party providers whose services we have added to our pages. The purpose of these cookies is to provide you with a more personalised experience on our site based on your previous visits and selections. If you do not allow these cookies then some or all of these services may not function properly.',
  },
  statistics: {
    title: 'Statistics Cookies',
    text: 'Volvo Cars uses Google Analytics, which gives us insights in to how you use our web sites. This data consists of; e.g., Which pages you viewed; which links you clicked on; how long you spent on a page; what device you have used; We use this data to help us understand how people use our web site and to ensure that it functions correctly. This data is not used for marketing or advertising and is not shared with third parties.',
  },
};

export const seo = {
  title: 'Cookies',
  description:
    'Information about which cookies we use. Cookies help us improve the user experience on our website.',
};

export default content;
